import { BASEURL, checktoken, headers } from '../../utils/helper'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from './other.slice';
import axios from 'axios';

const initialState = {
    data: [],
    total: 0,
    pages: 0,
    current: 0,
    error: null,
    loading: false,
}

export const AdminRideReq = createAsyncThunk('AdminRideReq', async ({ role, page }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/rides/list/${role}`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const SingleRideReq = createAsyncThunk('SingleRideReq', async ({ id }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/ride/${id}`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const RideSlice = createSlice({
    name: 'rideSlice',
    initialState: initialState,
    extraReducers: (builder) => {
        builder.addCase(AdminRideReq.pending, (state, action) => {
            state.loading = true
            state.total = 0
            state.pages = 0
            state.data = []
            state.current = 0
            return state
        })
        builder.addCase(AdminRideReq.fulfilled, (state, action) => {
            state.loading = false
            state.total = action.payload.total
            state.pages = action.payload.pages
            state.current = action.payload.current
            state.data = action.payload.data
            return state
        })
        builder.addCase(AdminRideReq.rejected, (state, action) => {
            state.loading = false
            state.total = 0
            state.pages = 0
            state.data = []
            state.current = 0
            state.error = 'Error occured'
        })
        builder.addCase(SingleRideReq.pending, (state, action) => {
            state.loading = true
            return state
        })
        builder.addCase(SingleRideReq.fulfilled, (state, action) => {
            state.loading = false
            return state
        })
        builder.addCase(SingleRideReq.rejected, (state, action) => {
            state.loading = false
            state.error = 'Error occured'
        })
        builder.addCase('LOGOUT', () => initialState)
    }
})

export default RideSlice.reducer